import { CancelSubscriptionForm } from "components/forms";
import { AnimatePresence, motion } from "framer-motion";
import { XMark } from "assets/icons";
import { Formik } from "formik";
import { cancelCustomerSubscription } from "services/customer.service";
import { toast } from "react-toastify";

const CancelSubscriptionModal = ({ landlordId, onClose, isOpen }) => {
  const initialValues = {
    comment: "",
    rating: "",
    reasons: [],
    otherReason: "",
    hasOtherReason: false,
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    setSubmitting(true);

    const body = {
      reason: values.hasOtherReason
        ? values.otherReason
        : values.reasons.join(", "),
      experience: values.rating,
      comment: values.comment,
      immediateCancel: false,
    };

    try {
      const response = await cancelCustomerSubscription(landlordId, body);

      const data = await response.data;

      if (!data.success) {
        throw new Error(data.message || "Failed to cancel subscription");
      }

      setSubmitting(false);
      onClose();
    } catch (err) {
      toast.error(err.message);
      setSubmitting(false);
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="fixed inset-0 flex justify-center items-end sm:items-center bg-black dark:bg-[#1467B0B5] bg-opacity-50 z-30"
          onClick={onClose}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          <motion.div
            onClick={(e) => e.stopPropagation()}
            className="w-full sm:w-auto sm:min-w-[480px] max-h-[90vh] bg-white dark:bg-slate-950 border dark:border-gray-800 rounded-t-xl sm:rounded-xl flex flex-col"
            initial={{ x: "-100vw", opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: "100vw", opacity: 0 }}
            transition={{ type: "spring", stiffness: 300, damping: 25 }}
          >
            <div className="w-full p-6 relative">
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-xl font-semibold text-gray-800 dark:text-white">
                  Subscription Cancellation Feedback Form
                </h2>
                <button
                  className="size-10 absolute right-3 top-3 hover:bg-[rgba(0,0,0,0.04)] dark:hover:bg-bgsecondary flex items-center justify-center rounded-full z-50 dark:text-white"
                  onClick={onClose}
                >
                  <XMark className="stroke-2" />
                </button>
              </div>
            </div>

            {/* Scrollable form container with hidden scrollbar */}
            <div className="overflow-y-auto px-6 pb-6 flex-1 [scrollbar-width:none] [-ms-overflow-style:none]">
              <div className="[&::-webkit-scrollbar]:hidden">
                <Formik initialValues={initialValues} onSubmit={handleSubmit}>
                  <CancelSubscriptionForm />
                </Formik>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CancelSubscriptionModal;
